import { useContext, useState } from "react";
import { cleanObject } from "../../../../../helpers";
import { ToastContext } from "../../../../../hooks/context";
import {
  useCreateTerminals,
  useUpdateTerminals,
} from "../../../../../hooks/api/mutations/useTerminals";
import { useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useGetInterwitchAccounts } from "../../../../../hooks/api/queries/useTerminals";

export const useConnectTerminal = ({
  terminalDetails = {},
  terminalType = "",
  fieldProps = {},
  isEditMode = false,
  setStep = () => {},
}) => {
  const [search] = useSearchParams();
  const triggerToast = useContext(ToastContext);
  const { storeList } = useSelector((state) => state.profileDetailsReducer);
  const [formDetails, setFormDetails] = useState({
    merchant_id: terminalDetails?.merchant_id || "",
    terminal_id: terminalDetails?.terminal_id || "",
    terminal_sn: terminalDetails?.terminal_sn || "",
    account_name: terminalDetails?.account_name || "",
    account_number: terminalDetails?.account_number || "",
    store_id: terminalDetails?.store?.id || "",
    use_static_account:
      terminalDetails?.use_static_account || fieldProps?.useStaticAccount,
    terminalType,
    use_on_checkout: terminalDetails?.use_on_checkout || false,
    interswitch_account_id:
      terminalDetails?.interswitch_account_id || search.get("account_id") || "",
  });
  const navigate = useNavigate();

  const { data, isLoading: isFetchingAccount } = useGetInterwitchAccounts({
    isEnabled: terminalType === "INTERSWITCH" ? true : false,
  });

  const { mutate: createTerminalMutate, isLoading: isCreatingTerminal } =
    useCreateTerminals();

  const { mutate: updateTerminalMutate, isLoading: isUpdatingTerminal } =
    useUpdateTerminals(terminalDetails?.id);

  const addTerminal = () => {
    const data = getSubmissionData();
    createTerminalMutate(data, {
      onSuccess: () => {
        triggerToast("Terminal creation successful", "success");
        const path = fieldProps.route(terminalType);
        if (path) return navigate(path);

        setStep((prev) => prev + 1);
      },
    });
  };

  const updateTerminal = () => {
    const data = getSubmissionData();
    updateTerminalMutate(data, {
      onSuccess: () => {
        triggerToast("Terminal update successful", "success");
        const path = fieldProps.route(terminalType);
        if (path) return navigate(path);

        setStep((prev) => prev + 1);
      },
    });
  };

  const connectTerminal = () => {
    if (isEditMode) updateTerminal();
    else addTerminal();
  };

  const getSubmissionData = () => {
    return cleanObject({
      merchant_id: formDetails?.merchant_id,
      terminal_id: formDetails?.terminal_id,
      terminal_sn: formDetails?.terminal_sn,
      store_id: formDetails?.store_id,
      terminal_type: formDetails?.terminalType,
      use_on_checkout: formDetails?.use_on_checkout,
      use_static_account: formDetails?.use_static_account,
      account_number: formDetails.account_number,
      account_name: formDetails?.account_name,
    });
  };

  return {
    isConnecting: isCreatingTerminal || isUpdatingTerminal,
    storeList,
    formDetails,
    interswitchAccounts: data?.data || [],
    isFetchingAccount,
    setFormDetails,
    connectTerminal,
  };
};
